import React, { useState, useEffect } from 'react';
import { Radios } from 'govuk-react-jsx/govuk/components/radios';
import { Button } from 'govuk-react-jsx/govuk/components/button';
import { ErrorSummary, Fieldset } from 'govuk-react-jsx';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setGrantTypeSelected,
  getGrantTypeSelected,
  setSelectedGrantValue,
  getSelectedGrantValue,
  setApplicantAnnualQuota,
  getApplicantAnnualQuota,
  getAvailableGrants,
  // getUnavailableGrants,
  setAvailableGrants,
  // setUnavailableGrants,
  setParkingTypeSelected,
} from '../../features/application/applicationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getGrantsData,
  getAccount,
  getPMCClientData,
  getConfigurableDeadlines,
} from '../../firebase';
// import { formatDate } from '../../utils/helpers';
import { checkIfEmpty } from '../../utils/validations';
import {
  setUserDetails,
  getUserDetails,
} from '../../features/dashboard/dashboardSlice';
import {
  getSelectedLandlordClient,
  setSelectedPMCClientData,
} from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';

const SelectGrantType = () => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [
    closeToCustomerApplicationCutoffDates,
    setCloseToCustomerApplicationCutoffDates,
  ] = useState({});
  const accountBusiness = useSelector(getSelectedLandlordClient);
  const selectedGrantObject = useSelector(getSelectedGrantValue);
  const applicantAnnualQuota = useSelector(getApplicantAnnualQuota);
  const grantTypeRedux = useSelector(getGrantTypeSelected);
  const availableGrantsRedux = useSelector(getAvailableGrants);
  // const unavailableGrantsRedux = useSelector(getUnavailableGrants);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const userDetails = useSelector(getUserDetails);
  const [errorList, setErrorList] = useState([]);

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'pmcApp.SelectGrantType.s18',
    'Apply for a grant - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const dispatch = useDispatch();
  const history = useHistory();

  // Error message
  const radioError = copyProvider.getCopy(
    'pmcApp.SelectGrantType.s5',
    'Select which grant you want to apply for'
  );
  // const unAvailableGrantsHint = (grants) => {
  //   const unAvailableGrants = grants.map((grant) => {
  //     return (
  //       <p
  //         className="govuk-body"
  //         key={grant.grantTypeLong + grant.grantAvailabilityStartDate}
  //       >
  //         {copyProvider.getCopy('pmcApp.SelectGrantType.s7', 'The')}{' '}
  //         {grant.grantTypeLong}{' '}
  //         {copyProvider.getCopy(
  //           'pmcApp.SelectGrantType.s8',
  //           'is not available until'
  //         )}{' '}
  //         {formatDate(grant.grantAvailabilityStartDate)}
  //       </p>
  //     );
  //   });
  //   return unAvailableGrants;
  // };

  const mainHeading = (grants) => {
    let heading;
    if (grants?.length > 1) {
      heading = copyProvider.getCopy(
        'pmcApp.SelectGrantType.s1',
        'Which type of grant do you want to apply for?'
      );
    } else {
      heading = `${copyProvider.getCopy(
        'pmcApp.SelectGrantType.s2',
        'You are applying for a'
      )} ${grants[0] ? grants[0].grantTypeShort : ''} grant`;
    }
    return heading;
  };

  // Handle radio button selection
  const onRadioChange = (event) => {
    const grantDocumentId = event.target.value;
    const selectedGrant = availableGrantsRedux.find(
      (grant) => grant.grantDocumentId === grantDocumentId
    );

    if (selectedGrant.grantTypeShort === 'commercial properties') {
      dispatch(
        setApplicantAnnualQuota(
          userDetails?.comm_count_of_applications_submitted_for_sockets_in_year
        )
      );
    } else {
      dispatch(
        setApplicantAnnualQuota(
          userDetails?.resi_count_of_applications_submitted_for_sockets_in_year
        )
      );
    }
    dispatch(setGrantTypeSelected(grantDocumentId));
    dispatch(setSelectedGrantValue(selectedGrant));
    dispatch(setParkingTypeSelected([]));
  };
  // check all grant in past dates
  const allGrantsInPastDates = () => {
    if (
      closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationCarParkResidential ===
        false &&
      closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationLandlordCommercialGrant ===
        false &&
      closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationLandlordResidentialGrant ===
        false
    ) {
      return true;
    }
    return false;
  };
  // Handle button function
  const handleButtonClick = () => {
    const showRadioErrorMsg = {
      children: radioError,
    };

    if (checkIfEmpty(grantTypeRedux)) {
      setErrorMsg(showRadioErrorMsg);
      setErrorList([{ ...showRadioErrorMsg, href: '#commercial' }]);
      return;
    }
    if (allGrantsInPastDates()) {
      history.push('/pmcApp/select-grant-type');
    } else if (applicantAnnualQuota >= selectedGrantObject?.quota) {
      history.push('/pmcApp/unable-to-start-new-application');
      // return;
    } else if (
      selectedGrantObject?.grantTypeShort === 'residential properties'
    ) {
      history.push('/pmcApp/private-parking');
    } else if (selectedGrantObject?.grantTypeShort === 'car parks') {
      getPMCClientData({
        pmcClientLandlordAccId: accountBusiness?.landlord_account_id,
      })
        .then((response) => {
          dispatch(setSelectedPMCClientData(response.data));
          if (
            response.data.getPmcClient?.carpark_resi_claim_count >=
            selectedGrantObject?.quota
          ) {
            window.location.assign('/car-parks/pmc-app/grant-limit-exceeded');
          } else {
            window.location.assign('/car-parks/pmc-app/declaration');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      history.push('/pmcApp/commercial/staff-and-fleet');
    }
  };

  useEffect(() => {
    const fetchWordingTemplates = async () => {
      try {
        setIsLoading(true);
        const configurableDeadlines = await getConfigurableDeadlines();
        if (!configurableDeadlines?.data) {
          setIsLoading(false);
          console.log('Configurable deadlines data is undefined');
        }
        setCloseToCustomerApplicationCutoffDates(
          configurableDeadlines.data.closeToCustomerApplicationDates
        );
        getGrantsData()
          .then((response) => {
            const { data } = response;
            dispatch(setAvailableGrants(data.availableGrants));
            // dispatch(setUnavailableGrants(data.unavailableGrants));
          })
          .catch((error) => {
            throw error;
          });

        getAccount()
          .then((response) => {
            const { data } = response;
            dispatch(setUserDetails(data));
          })
          .catch(() => {
            // TODO: Show error message
          });
      } finally {
        setIsLoading(false);
      }
    };
    fetchWordingTemplates();
  }, []);

  const getRadioItemText = (grantType) => {
    let item;

    if (
      grantType.grantTypeShort === 'car parks' &&
      process.env.REACT_APP_ENABLE_PMC_CARPARK.toLowerCase() === 'true'
    ) {
      item = {
        children: (
          <span key={grantType.grantTypeShort} className="govuk-label">
            {copyProvider.getCopy(
              'landlordApp.SelectGrantType.s12',
              'EV infrastructure grant for residential car parks'
            )}
          </span>
        ),
        hint: {
          children:
            closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationCarParkResidential ===
            false
              ? 'This grant type is no longer open to new applications.'
              : copyProvider.getCopy(
                  'landlordApp.SelectGrantType.s13',
                  'Helps with the cost of the infrastructure and chargepoints for a residential car park.'
                ),
        },
        value: grantType.grantDocumentId,
        id: 'carpark',
        disabled:
          closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationCarParkResidential ===
          false,
      };
    }
    if (grantType.grantTypeShort === 'commercial properties') {
      item = {
        children: (
          <span key={grantType.grantTypeShort} className="govuk-label">
            {copyProvider.getCopy(
              'pmcApp.SelectGrantType.s16',
              'EV chargepoint grant for commercial landlords'
            )}
          </span>
        ),
        hint: {
          children:
            closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationLandlordCommercialGrant ===
            false
              ? 'This grant type is no longer open to new applications.'
              : copyProvider.getCopy(
                  'pmcApp.SelectGrantType.s17',
                  'Helps with the cost of chargepoints only for a commercial car park. It will not pay towards infrastructure.'
                ),
        },
        value: grantType.grantDocumentId,
        id: 'commercial',
        disabled:
          closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationLandlordCommercialGrant ===
          false,
      };
    }

    if (grantType.grantTypeShort === 'residential properties') {
      item = {
        children: (
          <span key={grantType.grantTypeShort} className="govuk-label">
            {copyProvider.getCopy(
              'pmcApp.SelectGrantType.s14',
              'EV chargepoint grant for residential landlords'
            )}
          </span>
        ),
        hint: {
          children:
            closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationLandlordResidentialGrant ===
            false
              ? 'This grant type is no longer open to new applications.'
              : copyProvider.getCopy(
                  'pmcApp.SelectGrantType.s15',
                  'Helps with the cost of chargepoints for residential parking. It will not pay towards infrastructure.'
                ),
        },
        value: grantType.grantDocumentId,
        id: 'residential',
        disabled:
          closeToCustomerApplicationCutoffDates?.stopToCreateCustomerApplicationLandlordResidentialGrant ===
          false,
      };
    }
    return item;
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <span className="govuk-caption-l">
        {accountBusiness?.landlord_account_name}
      </span>
      <Fieldset
        legend={{
          children: (
            <h1 className="govuk-heading-xl govuk-!-margin-bottom-3">
              {mainHeading(availableGrantsRedux)}
            </h1>
          ),
        }}
      >
        <p className="govuk-body">
          {copyProvider.getCopy(
            'pmcApp.SelectGrantType.s9',
            'You can only select one for each application.'
          )}
        </p>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'pmcApp.SelectGrantType.s10',
            "It is important you follow your OZEV approved installer's recommendation on which grant you need to choose."
          )}
        </p>
        {/* {unAvailableGrantsHint(unavailableGrantsRedux)} */}
        <Radios
          errorMessage={errorMsg || null}
          onChange={onRadioChange}
          idPrefix="selectGrantType"
          items={availableGrantsRedux.map((grant) => {
            return getRadioItemText(grant);
          })}
          name="grant-type"
          value={grantTypeRedux}
        />
      </Fieldset>
      <Button onClick={handleButtonClick}>
        {copyProvider.getCopy('pmcApp.SelectGrantType.s4', 'Continue')}
      </Button>
    </>
  );
  if (isLoading) {
    return (
      <div className="govuk-grid-row">
        <p className="govuk-body">Loading...</p>
      </div>
    );
  }
  // Wait for configurable deadlines to be loaded before rendering
  if (!closeToCustomerApplicationCutoffDates) {
    return null;
  }
  return pageModel;
};

export default SelectGrantType;
